export type UnifilarPaletteIcon = {
    id: number;
    name: string;
};

export type UnifilarSelectableEquipment = {
    id: number;
    name: string;
    etsStatus?: string;
    equipmentType?: { id: number };
    image?: { id: number };
};

const COMBINER_TYPE_IDS = [1, 9] as const;
const INVERTER_TYPE_IDS = [2, 10] as const;
const TRANSFORMER_TYPE_IDS = [3, 17, 21] as const;
const PROTECTION_OR_BREAKER_TYPE_IDS = [4, 11, 12, 17, 18] as const;
const ENERGY_METER_TYPE_IDS = [5, 14, 15] as const;

const UNIFILAR_ICON_EQUIPMENT_TYPE_IDS: Record<string, readonly number[]> = {
    combiner: COMBINER_TYPE_IDS,
    'combiner box': COMBINER_TYPE_IDS,
    inversor: INVERTER_TYPE_IDS,
    transformador: TRANSFORMER_TYPE_IDS,
    rele: PROTECTION_OR_BREAKER_TYPE_IDS,
    'rele de protecao': PROTECTION_OR_BREAKER_TYPE_IDS,
    medidor: ENERGY_METER_TYPE_IDS,
    'medidor de energia': ENERGY_METER_TYPE_IDS,
    disjuntor: PROTECTION_OR_BREAKER_TYPE_IDS,
};

export function normalizeUnifilarIconName(name: string): string {
    return name
        .trim()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
}

function equipmentTypeIdsForIcon(icon: UnifilarPaletteIcon): readonly number[] | undefined {
    return UNIFILAR_ICON_EQUIPMENT_TYPE_IDS[normalizeUnifilarIconName(icon.name)];
}

export function hasUnifilarIconEquipmentMapping(icon: UnifilarPaletteIcon): boolean {
    return equipmentTypeIdsForIcon(icon) !== undefined;
}

export function isUnifilarUtilityPoleIcon(icon: UnifilarPaletteIcon): boolean {
    return icon.id === 5 || normalizeUnifilarIconName(icon.name) === 'poste';
}

export function filterEquipmentsForUnifilarIcon(
    icon: UnifilarPaletteIcon,
    equipmentList: UnifilarSelectableEquipment[],
): UnifilarSelectableEquipment[] {
    const typeIds = equipmentTypeIdsForIcon(icon);
    if (typeIds) {
        const allowed = new Set(typeIds);
        return equipmentList.filter((equipment) => (
            equipment.equipmentType?.id !== undefined && allowed.has(equipment.equipmentType.id)
        ));
    }
    return equipmentList.filter((equipment) => equipment.image?.id === icon.id);
}
